// extracted by mini-css-extract-plugin
export default {"subhead":"Subhead-module__subhead___Q54qe"};